import React from 'react'
import Navlite from '../../components/NavLite'
import Footer from '../../components/Footer'

function WireframeKits() {
  <main>
  <title>UX Wireframe Kits for Web Designers | Her Growth Co. Tools</title>
<meta
name="description"
content="Download professional wireframe kits used by our design team to plan and structure high-converting websites."
/>
<meta
name="keywords"
content="wireframes for women-led brands, web layout templates, site planning tools for founders, UX wireframe kits, structure for feminine websites, design starter packs for coaches, website architecture made easy"
/>
</main>
  return (
    <div>
    <Navlite/>
          <div className="text-center items-center justify-center text-9xl mt-10">
            Coming Soon
            </div>
            <Footer />
         
        </div>
  )
}

export default WireframeKits